export default {
  BASE_URL: 'https://dotconnect.dotandkey.com/api/v1',
  CREAD: 'CREAD',
  TOKEN: 'TOKEN',
};